<template>
  <a href="#" class="logo" @click.prevent="onClickLogo">
    <img
      v-if="isWavveOn"
      src="../../assets/images/common/ci-wavveon-142-x-24.svg"
      alt="Wavve on logo"
      class="wavveon-logo"
    />
    <img
      v-else
      src="../../assets/images/common/ci-wavve-112-x-24.svg"
      alt="Wavve"
      class="default wavve-logo"
    />
  </a>
</template>

<script>
  import { UPDATE_MAIN_LAYOUT_CONTENT } from '@/common/resources/const'
  import { LOG_SEND_LIST } from '@/common/resources/log.v2.const'
  import { sendEventLogExitToGnb } from '@/common/utils/log.v2.send'
  export default {
    name: 'WHeaderLogo',
    props: {
      isWavveOn: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      onClickLogo() {
        if (this.isWavveOn) {
          this.$router.push({ name: 'home' })
        } else {
          this.changeUrl({ path: '/index.html', name: 'home' })
        }
      },
      changeUrl({ path, name }) {
        if (this.$route.name === name) {
          this.$events.$emit(UPDATE_MAIN_LAYOUT_CONTENT)
        } else {
          if (LOG_SEND_LIST.includes(this.$route.name))
            sendEventLogExitToGnb({
              name: name,
              route: this.$route,
              landingUrl: path,
            })
          this.$router.push(path)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .logo {
    display: flex;
    align-items: center;
    height: 100%;
    .wavve-logo {
      width: 112px;
      height: 24px;
    }
    .wavveon-logo {
      width: 142px;
      height: 24px;
    }
  }
</style>
